import { render, staticRenderFns } from "./AgreementPolicy.vue?vue&type=template&id=bfee2b18&scoped=true"
import script from "./AgreementPolicy.vue?vue&type=script&lang=js"
export * from "./AgreementPolicy.vue?vue&type=script&lang=js"
import style0 from "./AgreementPolicy.vue?vue&type=style&index=0&id=bfee2b18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfee2b18",
  null
  
)

export default component.exports